import { User } from "@heroui/react";
import Link from "next/link";

interface UserProfileProps {
  obj: {
    nickname?: string;
    first_name?: string;
    [key: string]: any;
  };
  className?: string;
  hasLink?: boolean;
  name?: string;
}

export default function UserProfile({ 
  obj, 
  className='', 
  hasLink=true, 
  name = '' 
}: UserProfileProps) {
    // Defensive check for obj
    if (!obj || !obj.nickname) {
      return <div className="text-gray-500">Użytkownik niedostępny</div>;
    }
    
    const nickname = obj.nickname || 'użytkownik';
    const displayName = name || nickname;
    
    return (
        <Link href={`/u/${nickname}`} className={className}>
            <User
                avatarProps={{ 
                  radius: "sm", 
                  size: "md", 
                  name: obj.first_name || nickname 
                }}
                classNames={{
                    description: "text-default-500",
                }}
                description={ hasLink && (
                    <Link className="text-blue-500 font-semibold" href={`/u/${nickname}`}>
                        @{nickname}
                    </Link>
                )}
                name={displayName}
            >
                {nickname}
            </User>
        </Link>
    );
}
